import type { InputSignal, Type } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';

export interface ChatPresenterComponent<TArgs> {
  readonly args: InputSignal<TArgs>;
}

export interface RenderPresenter<TArgs = unknown> {
  readonly id: string;
  readonly component: Type<ChatPresenterComponent<TArgs>>;
}

export const {
  provide: provideTellentAssistantRenderPresenter,
  inject: injectTellentAssistantRenderPresenters,
} = createProviderToken<RenderPresenter>('TELLENT_ASSISTANT_RENDER_PRESENTERS')(true);
